import styled from "styled-components";
import { TS_DIGITAL_IMAGES } from "../../config";

export const Container = styled.div`
    min-height: 100vh;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const Header = styled.header`
    height: 4rem;
    background-color: ${props => props.theme.colors.text.yankeesBlue};
    box-shadow: 0px 2px 8px 0px rgba(21, 41, 53, 0.32);
    position: relative;
    color: ${props => props.theme.colors.background.white};
    font-size: 1rem;
    font-family: Roboto;
    font-weight: bold;
    letter-spacing: 0px;
    line-height: 1rem;
    display: flex;
    align-items: center;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
`;

export const ContentWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    @media (max-width: 1200px) {
        flex-direction: column;
    }
`;

export const Sidebar = styled.div`
    width: 100%;
    min-height: calc(100vh - 4rem);
    background-color: ${props => props.theme.colors.background.white};
    padding: 3.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: 1200px) {
        width: 100%;
        padding: 2.5rem 1rem;
    }
`;

export const AdvertisingContainer = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-image: url(${TS_DIGITAL_IMAGES}prelogin/bgblue.svg);
    background-size: cover;
    background-repeat: no-repeat;

    @media (max-width: 1200px) {
        display: none;
    }
`;

export const LogoContainer = styled.div`
    width: 165px;

    @media (max-width: 992px) {
        margin: 0 auto;
    }
`;

export const Logo = styled.img`
    width: 100%;
`;

export const Title = styled.div`
    color: ${props => props.theme.colors.primary.darkImperialBlue};
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    font-size: 2.5rem;
    font-family: Cairo;
    font-weight: bold;
    letter-spacing: 0.31px;
    line-height: 3rem;
    margin-bottom: 1rem;
    max-width: 35vw;
    @media (max-width: 992px) {
        max-width: 80vw;
    }
    @media ((min-width: 993px) and (max-width: 1200px)) {
        max-width: 80vw;
    }
`;
export const EmailWrapper = styled.div`
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    max-width: 30vw;
    @media (max-width: 992px) {
        max-width: 30vw;
    }
    @media ((min-width: 993px) and (max-width: 1200px)) {
        max-width: 80vw;
    }
`;
export const AdvertisingEmailWrapper = styled.div`
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    max-width: 35vw;
    @media (max-width: 991px) {
        max-width: 30vw;
    }
    @media ((min-width: 992px) and (max-width: 1200px)) {
        max-width: 60vw;
    }
`;
export const LoginContainer = styled.div`
    margin-top: 8rem;
    margin-bottom: 3rem;
    display: flex;
    flex-direction: column;

    @media (max-width: 992px) {
        max-width: 374px;
        margin-left: auto;
        margin-right: auto;
    }
`;

export const Subtitle = styled.div`
    color: ${props => props.theme.colors.primary.darkImperialBlue};
    font-size: 1.125rem;
    font-family: Cairo;
    font-weight: 600;
    letter-spacing: 0.14px;
    line-height: 24px;
    margin-bottom: 0.625rem;
`;

export const Description = styled.div`
    color: ${props => props.theme.colors.text.cadet};
    font-size: 1rem;
    font-family: Roboto;
    font-weight: normal;
    letter-spacing: 0.44px;
    line-height: 1.5rem;
`;

export const InfoContainer = styled.div`
    background-color: ${props => props.theme.colors.background.whiteSmoke};
    padding: 1rem;
    color: ${props => props.theme.colors.text.yankeesBlue};
    font-size: 0.875rem;
    font-family: Roboto;
    letter-spacing: 0.25px;
    line-height: 1.5rem;
    font-weight: normal;
    display: flex;
    gap: 0.5rem;
    margin-top: 1rem;
    margin-bottom: 1.5rem;
`;

export const InfoIcon = styled.div`
    color: ${props => props.theme.colors.primary.darkImperialBlue};
    font-size: 1rem;
`;

export const AdvertisingBox = styled.div`
    max-width: 869px;
    background: linear-gradient(360deg, rgba(243, 246, 249, 0) 0%, rgba(255, 255, 255, 0.7) 100%) no-repeat,
        url(${props => props.backgroundImage}) no-repeat;
    border-radius: 0.5rem;
    padding: 4rem;
    margin: 2rem;
    position: relative;
    background-size: cover, 200px; /* First value for gradient, second for image */
    background-position: center, bottom right; /* First value for gradient, second for image */
    @media (max-width: 1240px) {
        display: none;
    }

    @media (min-width: 1241px) {
        background-size: cover, 264px; /* First value for gradient, second for image */
    }

    @media (min-width: 1821px) {
        background-size: cover, 340px; /* First value for gradient, second for image */
    }
`;
